export const GET_TEACHER_AUTH_TOKEN_REQUEST = 'GET_TEACHER_AUTH_TOKEN_REQUEST';
export const GET_TEACHER_AUTH_TOKEN_SUCCESS = 'GET_TEACHER_AUTH_TOKEN_SUCCESS';
export const GET_TEACHER_AUTH_TOKEN_FAILURE = 'GET_TEACHER_AUTH_TOKEN_FAILURE';
export const GET_TEACHER_LOGIN_FAILURE = 'GET_TEACHER_LOGIN_FAILURE';

export function getTeacherAuthTokenRequest(userProfileType, userProfileId) {
    return { type: GET_TEACHER_AUTH_TOKEN_REQUEST, userProfileType, userProfileId, isGettingToken: true };
}

export function getTeacherAuthTokenSuccess({ redirectUri, mathleticsToken }) {
    return { type: GET_TEACHER_AUTH_TOKEN_SUCCESS, redirectUri, authToken: mathleticsToken, isGettingToken: false };
}

export function getTeacherLoginFailure(error) {
    return { type: GET_TEACHER_LOGIN_FAILURE, error, isGettingToken: false };
}

export function getTeacherAuthTokenFailure() {
    return { type: GET_TEACHER_AUTH_TOKEN_FAILURE, isGettingToken: false };
}



// WEBPACK FOOTER //
// ./app/containers/teacher-view/actions.js